import COLORS from '@/constants/colors';
import { Box, Divider } from '@mui/material';
import { ReactNode } from 'react';

export function BasicContainer(props: {
  content: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <Box
      sx={{
        border: `1px solid ${COLORS.gray_300}`,
        borderRadius: '10px',
        backgroundColor: COLORS.white,
      }}
    >
      {props.content}
      {props.footer && (
        <>
          <Divider sx={{ borderColor: COLORS.gray_300 }} />
          {props.footer}
        </>
      )}
    </Box>
  );
}
